import React from 'react'
import { Link } from 'react-router-dom'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import ClientWiseSummaryUI from '../../../components/superUser/nodalTxn/ClientWiseSummaryUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import './ClientWiseSummaryPage.css'

const ClientWiseSummaryPageUI = ({
  context, errorList, accountNumber, onRefreshClick,
  accountSummaryList, loading,
  downloadMode, onDownloadClick,
  yearMonthLabel, isCurrentMonth, onPreviousClick, onNextClick
}) =>
  <SuperUserTxnPageUI context={context} className='pg_su_txn_cws' topnav='transactions'
    headerText='Client-Wise Summary' dimension='w1600'
    page={accountNumber === '007105010733' ? '0733summary' : '4441summary'}
  >
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }

    <LRTableActionsUI location='top'
      left={
        <div className='g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          <span className='cws_download_group'>
            <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Excel' />
            <SpinnerUI className='cws_download_spinner' reserveSpace={false} show={downloadMode} />
          </span>
          <span className='g_m_left_100 g_large'>
            <b>Client-Wise Summary</b>
            <span className='g_m_left_50 g_muted'>{accountNumber}</span>
            {yearMonthLabel && <span className='g_m_left_50 g_muted'>· {yearMonthLabel}</span>}
          </span>
        </div>
      }
      right={
        <span className='cws_month_nav'>
          <Link to='#' className='cws_nav_link' onClick={onPreviousClick}>← Previous</Link>
          {!isCurrentMonth &&
            <Link to='#' className='cws_nav_link' onClick={onNextClick}>Next →</Link>
          }
        </span>
      }
    />

    {
      loading &&
      <div className='cws_page_spinner'>
        <SpinnerComponentUI context={context} />
      </div>
    }
    {
      !loading && accountSummaryList !== null &&
      <ClientWiseSummaryUI accountSummaryList={accountSummaryList} />
    }
  </SuperUserTxnPageUI>

export default ClientWiseSummaryPageUI
